export default {
  meta: {
    title: '审核详情'
  }
};
